import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=53dacaec&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=ts"
export * from "./TextField.vue?vue&type=script&lang=ts"
import style0 from "./TextField.vue?vue&type=style&index=0&id=53dacaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dacaec",
  null
  
)

export default component.exports